import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import HeroSearch from "./components/HeroSearch";
import ExclusiveDeals from "./components/ExclusiveDeals";
import SpecialOffers from "./components/SpecialOffers";
import LimitedTimePromo from "./components/LimitedTimePromo";
import ExploreDestinations from "./components/ExploreDestinations";
import TravelCollections from "./components/TravelCollections";

export type TravelMode = "tour" | "cruise";

// Redesigned GD landing page, shown at /web. Composes the redesigned
// sections while each block owns its API integration and fallback behavior.
export default function Homepage() {
  const [searchParams] = useSearchParams();
  const initialMode: TravelMode = searchParams.get("type") === "cruise" ? "cruise" : "tour";

  // Tour/Cruise mode is owned here so the hero toggle can drive section content
  // (e.g. the Explore section title changes in cruise mode).
  const [mode, setMode] = useState<TravelMode>(initialMode);

  return (
    <div id="homepage-v2">
      <HeroSearch mode={mode} onModeChange={setMode} />
      <div className="homepage-v2__content">
        <ExclusiveDeals mode={mode} />
        <SpecialOffers mode={mode} />
        <LimitedTimePromo />
        <ExploreDestinations mode={mode} />
        <TravelCollections />
      </div>
    </div>
  );
}
